import React, { useEffect, useState } from 'react';
import NavBar from '../_components/navbar';
import { connect, useDispatch } from "react-redux";
import { bannerAction } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import {
    Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader,
    Button, ButtonGroup, Container, Row, Col, FormGroup, Label, Input, Form
} from 'reactstrap';
import { uploadFile } from '../_services'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndo, faCheck } from '@fortawesome/free-solid-svg-icons'
import './styles.css';
import Swal from 'sweetalert2';

const BannerEdit = (props) => {

    const dispatch = useDispatch();
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        const { match: { params } } = props;

        if (params.id) {
            dispatch(bannerAction.getBannerById(params.id, true));
        } else {
            dispatch(bannerAction.clear());
        }

    }, []);

    const setFile = (event) => {
        if (event.target.files && event.target.files[0]) {
            let fileUpload = event.target.files[0];
            setUploading(true);
            uploadFile(fileUpload)
                .then((response) => {
                    setUploading(false);
                    let event2 = {
                        target: {
                            value: response
                        }
                    };
                    dispatch(bannerAction.onChangeProps('caminho_imagem', event2));
                })
                .catch((err) => {
                    console.log(err);
                    setUploading(false);
                });
        }
    }

    const handleChange = prop => event => {
        dispatch(bannerAction.onChangeProps(prop, event));
    };

    const handleValidation = () => {

        var valid = true;
        var errors = '';

        if (!props.banner.nome) {
            valid = false;
            errors += '<li style="float:left;">Informe o Nome!</li><br>';
        }

        if (!props.banner.descricao) {
            valid = false;
            errors += '<li style="float:left;">Informe a Descrição!</li><br>';
        }

        //if (!props.banner.caminho_imagem) {
        //    valid = false;
        //    errors += '<li style="float:left;">Selecione uma Imagem!</li><br>';
        //}

        if (!props.banner.link) {
            valid = false;
            errors += '<li style="float:left;">Informe o Link!</li><br>';
        }

        if (!valid) {

            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });

        }

        return valid;

    };

    const handleSubmit = event => {

        event.preventDefault();
        const { match: { params } } = props;

        if (handleValidation()) {

            let payload = {
                id: params.id,
                nome: props.banner.nome,
                descricao: props.banner.descricao,
                caminho_imagem: props.banner.caminho_imagem,
                link: props.banner.link,
            }

            if (params.id) {
                dispatch(bannerAction.editBannerInfo(params.id, payload));
            } else {
                dispatch(bannerAction.createBanner(payload));
            }

        }

    };

    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Breadcrumb>
                                    <BreadcrumbItem><a href="/banners">Lista de Banner</a></BreadcrumbItem>
                                    <BreadcrumbItem active>{props.match.params.id ? `Banner ${props.match.params.id}` : 'Novo Banner'}</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={(event) => handleSubmit(event)}>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label className="left" for="nome">Nome *</Label>
                                        <Input
                                            type="text"
                                            name="nome"
                                            id="nome"
                                            value={props.banner.nome || ''}
                                            onChange={handleChange('nome')}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label className="left" for="descricao">Descrição *</Label>
                                        <Input
                                            type="text"
                                            name="descricao"
                                            id="descricao"
                                            value={props.banner.descricao || ''}
                                            onChange={handleChange('descricao')}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label className="left" for="caminho_imagem">Imagem *</Label>
                                        <Input
                                            type="file"
                                            name="caminho_imagem"
                                            id="caminho_imagem"
                                            onChange={(e) => setFile(e)}
                                            disabled={uploading}
                                        />
                                        {uploading ? <Label className="left" style={{ fontSize: 12, marginTop: 3 }}>Enviando arquivo...</Label> :
                                            (props.banner.caminho_imagem ? <Label className="left" style={{ fontSize: 12, marginTop: 3 }}>Arquivo atual: {props.banner.caminho_imagem}</Label> : '')
                                        }
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label className="left" for="link">Link *</Label>
                                        <Input
                                            type="text"
                                            name="link"
                                            id="link"
                                            value={props.banner.link || ''}
                                            onChange={handleChange('link')}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <br />
                            <Row>
                                <Col className="left" md="8" lg="6">
                                    <span>* Campos obrigatórios</span>
                                </Col>
                                <Col className="d-flex flex-row-reverse" md="4" lg="6">
                                    <ButtonGroup>
                                        <Button variant="contained" className="mr-1" color="secondary" component='a' href="/banners">Voltar <FontAwesomeIcon icon={faUndo} /></Button>
                                        <Button variant="contained" className="mr-1" color="primary" type="submit" disabled={uploading}>Salvar <FontAwesomeIcon icon={faCheck} /></Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </Container>

            
        </div>
    );

}

const mapStateToProps = (state) => {
    return state;
}

const connectedBannerEditPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(BannerEdit));
export { connectedBannerEditPage as BannerEdit };